import { adminInstance } from "@/api/instance";

export default async function (params) {
  return adminInstance.get("/beauty", { params });
}
